import * as React from "react";
import { CSSTransition } from "react-transition-group";
import Login from "./public-sign-in/Login";
import Csrf from "./commons/model/Csrf";
import { createRoot } from "react-dom/client";

export interface SignInProps {
  loginErrorMessages?: string;
  loginNameError?: boolean;
  loginDateError?: boolean;
  contactUsEmail: string;
  csrf: Csrf;
}

enum SignInStatus {
  LOGIN = "LOGIN",
}

export default function PublicSignIn({
  loginErrorMessages,
  csrf,
  loginNameError,
  loginDateError,
}: SignInProps) {
  const initialStatus = SignInStatus.LOGIN;

  const login = (
    <Login
      errorMessages={loginErrorMessages ? loginErrorMessages.split(",") : []}
      csrf={csrf}
      loginNameError={loginNameError}
      loginDateError={loginDateError}
    />
  );

  const componentByStatus = {
    LOGIN: login,
  };

  return (
    <>
      {Object.keys(SignInStatus).map((status) => (
        <CSSTransition
          classNames="todo" // LongTermFix jladron 07/02/2019: enable a nice css transformation if needed
          timeout={0}
          key={status}
          in={status === initialStatus}
          mountOnEnter={true}
          unmountOnExit={true}
        >
          {componentByStatus[status]}
        </CSSTransition>
      ))}
    </>
  );
}

PublicSignIn.loadComponent = (elementId: string, props: SignInProps) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<PublicSignIn {...props} />);
};
